import { computed } from 'vue';
import { useStore } from 'vuex';

export function useFont() {
  const store = useStore();
  
  // Current font settings from store
  const fontFamily = computed(() => store.state.font.fontFamily);
  const fontSize = computed(() => store.state.font.fontSize);
  const fontWeight = computed(() => store.state.font.fontWeight);
  const lineHeight = computed(() => store.state.font.lineHeight);
  const letterSpacing = computed(() => store.state.font.letterSpacing);
  const textColor = computed(() => store.state.font.textColor);
  
  // CSS classes
  const fontClasses = computed(() => store.getters['font/combinedClasses']);
  
  // Set font properties
  const setFontFamily = (family) => {
    store.commit('font/SET_FONT_FAMILY', family);
  };
  
  const setFontSize = (size) => {
    store.commit('font/SET_FONT_SIZE', size);
  };
  
  const setFontWeight = (weight) => {
    store.commit('font/SET_FONT_WEIGHT', weight);
  };
  
  const setLineHeight = (height) => {
    store.commit('font/SET_LINE_HEIGHT', height);
  };
  
  const setLetterSpacing = (spacing) => {
    store.commit('font/SET_LETTER_SPACING', spacing);
  };
  
  const setTextColor = (color) => {
    store.commit('font/SET_TEXT_COLOR', color);
  };
  
  // Set all font properties at once
  const setFont = (options) => {
    store.dispatch('font/setFontStyle', options);
  };
  
  return {
    // Current values
    fontFamily,
    fontSize,
    fontWeight,
    lineHeight,
    letterSpacing,
    textColor,
    
    // Combined classes
    fontClasses,
    
    // Setters
    setFontFamily,
    setFontSize,
    setFontWeight,
    setLineHeight,
    setLetterSpacing,
    setTextColor,
    setFont
  };
}